<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useTaskInfoMenu } from '../../model/info/task-info-menu.hook'

defineOptions({
  name: 'TaskInfoMenu',
})

const {
  config,
} = useTaskInfoMenu()
</script>

<template>
  <NavigationLinkTabs
    :config="config"
  />
</template>